import React from 'react';

const CartHeader = ({
  title    = 'סל השיעורים',
  subtitle = 'צפייה בשיעורים שבחרת לפני השלמת התשלום',
  itemsCount,
  total,
  currency = '₪',
}) => {
  const hasChips = Number.isFinite(itemsCount) || Number.isFinite(total);

  return (
    <section className="mx-auto max-w-8xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
      <div className="relative overflow-hidden rounded-2xl sm:rounded-3xl">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-50 to-blue-50" />

        <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-2xl sm:rounded-3xl p-4 sm:p-5 lg:p-6 shadow-2xl shadow-indigo-100/50">
          <div className="flex items-center justify-between gap-3 sm:gap-4">

            {/* Icon + text */}
            <div className="flex items-center gap-3 sm:gap-4 min-w-0">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl sm:rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
                <svg
                  viewBox="0 0 24 24"
                  className="w-5 h-5 sm:w-6 sm:h-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  aria-hidden="true"
                >
                  <path d="M3 5h2l2.6 10.4a2 2 0 0 0 2 1.6h7.5a2 2 0 0 0 1.95-1.56L21 8H7" />
                  <circle cx="10" cy="20" r="1.6" />
                  <circle cx="17" cy="20" r="1.6" />
                </svg>
              </div>

              <div className="min-w-0 flex-1">
                <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                  {title}
                </h1>
                {subtitle && (
                  <p className="text-sm sm:text-base text-gray-600 mt-0.5 sm:mt-1 line-clamp-2 sm:truncate">
                    {subtitle}
                  </p>
                )}
              </div>
            </div>

            {/* Chips */}
            {hasChips && (
              <div className="flex-shrink-0 flex flex-col sm:flex-row items-end sm:items-center gap-1.5 sm:gap-2">
                {Number.isFinite(itemsCount) && (
                  <span className="inline-flex items-center rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100 px-2.5 sm:px-3 py-1 text-xs sm:text-sm whitespace-nowrap">
                    {itemsCount} פריטים
                  </span>
                )}
                {Number.isFinite(total) && (
                  <span className="inline-flex items-center rounded-full bg-purple-50 text-purple-700 border border-purple-100 px-2.5 sm:px-3 py-1 text-xs sm:text-sm whitespace-nowrap">
                    סה״כ: {currency}{total.toFixed(2)}
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartHeader;